export enum SpendFrequency {
  YEARLY = 'yearly',
  BIYEARLY = 'biyearly',
  QUARTERLY = 'quarterly',
  MONTHLY = 'monthly',
  BIMONTHLY = 'bimonthly',
}
